var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXInfo = function SvgXInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.496 5.924c0 .771.615 1.377 1.387 1.377.781 0 1.387-.606 1.377-1.377 0-.781-.596-1.397-1.377-1.397-.772 0-1.387.616-1.387 1.397ZM8.182 18.11c0 .508.361.84.898.84h5.83c.547 0 .899-.332.908-.84 0-.508-.361-.83-.908-.83h-1.767v-6.894c0-.547-.352-.899-.89-.899h-2.91c-.546 0-.898.323-.898.83 0 .498.362.84.899.84h1.943v6.123H9.08c-.537 0-.898.323-.898.83Z"
  })));
};
export default SvgXInfo;